import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import i18n from 'i18next';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //


const getWithdrawalManagement = () => ({
    id: 'withdrawal',
    type: 'group',
    children: [
        {
            id: 'withdrawal',
            title: i18n.t('sidemenu.withdrawalManagement'),
            type: 'item',
            url: '/withdrawal',
            icon: LocalAtmIcon,
            breadcrumbs: false,
        },
    ]
});

export default getWithdrawalManagement;
